import { render, staticRenderFns } from "./tschedule.vue?vue&type=template&id=b2ab97c2&scoped=true"
import script from "./tschedule.vue?vue&type=script&lang=js"
export * from "./tschedule.vue?vue&type=script&lang=js"
import style0 from "./tschedule.vue?vue&type=style&index=0&id=b2ab97c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ab97c2",
  null
  
)

export default component.exports